<mat-card class="policy-view">
    <mat-card-header>
        <mat-card-title>Privacy Policy</mat-card-title>
        <mat-card-subtitle>This Privacy Policy explains how Av's Emprize LLC collects, uses, discloses, and protects information about users of our mobile application Price Matcher.</mat-card-subtitle>

    </mat-card-header>


<!-- Include the rest of your privacy policy content here, using HTML tags like <p>, <h2>, etc. -->
<mat-card-content class="policy-content">
    <h3>1. Introduction</h3>
<p>Your privacy is important to us. <strong>Price Matcher</strong> is committed to ensuring that your privacy is protected. This Privacy Policy outlines what information we collect, how it is used, and how you can control it.</p>

<h3>2. Data Collection</h3>
<p>At this time, <strong>Price Matcher</strong> does <strong>not collect any personal information</strong> from users. No data is stored, shared, or sold. If the application implements a login system in the future, any changes to this Privacy Policy, including how personal data is handled, will be communicated to all users.</p>

<h3>3. Cookies</h3>
<p>We do not use cookies or any form of tracking mechanisms at this stage. The platform is designed to function without collecting any user-specific data.</p>

<h3>4. Links to Third-Party Sites</h3>
<p><strong>Price Matcher</strong> may contain links to external websites. Once you leave our platform and visit an external site, we have no control over their content, privacy practices, or the protection of any information you may provide while visiting such sites.</p>

<h3>5. Security</h3>
<p>As we do not collect any data, there is no risk of your personal information being compromised. Should we collect data in the future (e.g., for login or preferences), we will implement appropriate technical and organizational measures to secure any information we collect.</p>

<h3>6. Changes to the Privacy Policy</h3>
<p>This Privacy Policy may be updated to reflect any new features or changes to the Service, including but not limited to the collection of data for login systems or personalization. Users will be notified of any updates through the platform.</p>

<h3>7. Contact Information</h3>
<p>If you have any questions or concerns about our Privacy Policy or your privacy while using <strong>Price Matcher</strong>, please reach out to us at <strong>support&#64;avsemprize.com</strong>.</p>
</mat-card-content>
</mat-card>